import type { UserModel } from '../../administration/types/UserModel';
import appClient from './AppClient';
import { endpoints } from '../../../config';

export default class UserProfileService {
    updateUserProfile(data: FormData) {
        const url = endpoints.usersUrl + 'userProfile';
        return appClient.post(url, data);
    }

    async getAvatarIcon(fileId: string): Promise<Blob | undefined> {
        const url = `${endpoints.usersUrl}userProfile/icon/${fileId}`;
        const resp = await appClient.get<Blob | undefined>(url, 'blob');
        return resp.mapErr(err => console.log(err)).unwrapOr(undefined);
    }

    getUserByName(name: string) {
        const url = `${endpoints.usersUrl}${name}`;
        return appClient.get<UserModel>(url);
    }

    async updatePinnedProjects(pinnedProjectIds: string[]) {
        const url = endpoints.usersUrl + 'userProfile/update-pinned-projects';
        return appClient.post(url, { pinnedProjectIds });
    }
}
